import React from 'react';

import type { UUID } from '@aline/common';
import { useNavigate } from 'react-router-dom';
import { ActivitySubscribers } from 'src/components/activity';
import { PanelHeader } from 'src/components/generic';
import { WorkflowActivitySection } from 'src/components/workflow/workflow-detail/side-panel/WorkflowActivitySection';
import { makeStyles } from 'tss-react/mui';

import { useWorkflowDetailLinks } from '../WorkflowDetailContext';

const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  // Push the subscriber control to the right edge of the header, past the "Activity" title.
  headerAction: {
    marginLeft: 'auto',
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

interface CommentsPanelProps {
  workflowId: UUID;
}

export const CommentsPanel = React.memo(function CommentsPanel({ workflowId }: CommentsPanelProps) {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const links = useWorkflowDetailLinks(workflowId);

  return (
    <div className={classes.wrapper}>
      <PanelHeader showBackButton text="Activity" onClickBack={() => navigate(links.baseUrl())}>
        <div className={classes.headerAction}>
          <ActivitySubscribers workflowId={workflowId} />
        </div>
      </PanelHeader>
      <div className={classes.content}>
        <WorkflowActivitySection workflowId={workflowId} />
      </div>
    </div>
  );
});
